import React, { useState, useContext } from 'react';
import { UserContext } from '../../../../context/global states/UserState';

export const VotesTemplate = ({ currentUpvotes }) => {
  const { incrementUpvote, decrementUpvote } = useContext(UserContext);
  const [upvotes, setUpvotes] = useState(currentUpvotes);

  // increment votes
  const increaseVotes = (e) => {
    // toggle button
    if (e.target.classList.contains('alt')) {
      setUpvotes(upvotes - 1);
      const id = e.target.parentElement.parentElement.parentElement.id.substr(
        1
      );
      e.target.classList.remove('alt');
      e.target.nextElementSibling.classList.remove('alt-text');
      e.target.setAttribute('viewBox', '0 0 24 24');
      e.target
        .querySelector('path')
        .setAttribute(
          'd',
          'm1.75 24h2.5c.965 0 1.75-.785 1.75-1.75v-.366c1.512.77 4.946 2.116 10.531 2.116h1.6c2.318 0 4.286-1.658 4.679-3.942l1.12-6.5c.238-1.387-.145-2.797-1.049-3.871-.903-1.072-2.227-1.687-3.63-1.687h-4.536c.283-.76.566-1.868.566-3.25 0-3.757-2.126-4.75-3.25-4.75-2.076 0-2.25 1.936-2.25 3.75 0 2.214-2.483 4.054-3.794 4.872-.067-.904-.816-1.622-1.737-1.622h-2.5c-.965 0-1.75.785-1.75 1.75v13.5c0 .965.785 1.75 1.75 1.75zm9.531-20.25c0-2.25.381-2.25.75-2.25.704 0 1.75.866 1.75 3.25 0 2.216-.868 3.574-.874 3.584-.153.23-.168.526-.037.77.13.244.385.396.661.396h5.72c.96 0 1.865.42 2.483 1.153.619.734.881 1.7.718 2.649l-1.12 6.5c-.269 1.562-1.615 2.697-3.201 2.697h-1.6c-6.803.001-10.211-2.127-10.531-2.338v-9.81c.833-.442 5.281-2.972 5.281-6.601zm-9.781 5c0-.138.112-.25.25-.25h2.5c.138 0 .25.112.25.25v13.5c0 .136-.114.25-.25.25h-2.5c-.138 0-.25-.112-.25-.25z'
        );
      decrementUpvote(id);
    } else {
      setUpvotes(upvotes + 1);
      const id = e.target.parentElement.parentElement.parentElement.id.substr(
        1
      );
      e.target.classList.add('alt');
      e.target.nextElementSibling.classList.add('alt-text');
      e.target.setAttribute('viewBox', '0 0 513 513');
      e.target
        .querySelector('path')
        .setAttribute(
          'd',
          'M37.8333 512H91.1667C111.753 512 128.5 495.253 128.5 474.667V466.859C160.756 483.285 234.015 512 353.161 512H387.295C436.745 512 478.729 476.629 487.113 427.904L511.007 289.237C516.084 259.648 507.913 229.568 488.628 206.656C469.364 183.787 441.119 170.667 411.188 170.667H322.117C328.155 154.453 326.495 130.816 326.495 101.333C326.495 21.184 281.14 0 257.161 0C212.873 0 209.161 41.3013 209.161 80C209.161 127.232 156.191 166.485 128.223 183.936C126.793 164.651 110.815 149.333 91.1667 149.333H37.8333C17.2467 149.333 0.5 166.08 0.5 186.667V474.667C0.5 495.253 17.2467 512 37.8333 512ZM241.161 80C241.161 32 249.289 32 257.161 32C272.18 32 294.495 50.4747 294.495 101.333C294.495 148.608 275.977 177.579 275.849 177.792C272.585 182.699 272.265 189.013 275.06 194.219C314.42 667 458.271 445.5 464.159 445.5L511.007 289.237C464.159 276.198 427 258.5 439.5 220.5C430.924 231.736 411.188 253 479.476 283.776L455.583 422.443C449.844 455.765 421.129 479.979 387.295 479.979H353.161C208.031 480 359.988 516.501 353.161 512L387.295 489.5C488.628 186.667 241.161 157.419 241.161 80ZM32.5 186.667C32.5 183.723 34.8893 181.333 37.8333 181.333H91.1667C94.1107 181.333 96.5 183.723 96.5 186.667V474.667C96.5 477.568 94.068 480 91.1667 480H37.8333C34.8893 480 32.5 477.611 32.5 474.667V186.667Z'
        );
      incrementUpvote(id);
    }
  };

  return (
    <div className='votes'>
      <div className='upvotes'>
        <svg
          height='513'
          viewBox='0 0 24 24'
          width='513'
          xmlns='http://www.w3.org/2000/svg'
          id='upvote'
          onClick={increaseVotes}
        >
          <path d='m1.75 24h2.5c.965 0 1.75-.785 1.75-1.75v-.366c1.512.77 4.946 2.116 10.531 2.116h1.6c2.318 0 4.286-1.658 4.679-3.942l1.12-6.5c.238-1.387-.145-2.797-1.049-3.871-.903-1.072-2.227-1.687-3.63-1.687h-4.536c.283-.76.566-1.868.566-3.25 0-3.757-2.126-4.75-3.25-4.75-2.076 0-2.25 1.936-2.25 3.75 0 2.214-2.483 4.054-3.794 4.872-.067-.904-.816-1.622-1.737-1.622h-2.5c-.965 0-1.75.785-1.75 1.75v13.5c0 .965.785 1.75 1.75 1.75zm9.531-20.25c0-2.25.381-2.25.75-2.25.704 0 1.75.866 1.75 3.25 0 2.216-.868 3.574-.874 3.584-.153.23-.168.526-.037.77.13.244.385.396.661.396h5.72c.96 0 1.865.42 2.483 1.153.619.734.881 1.7.718 2.649l-1.12 6.5c-.269 1.562-1.615 2.697-3.201 2.697h-1.6c-6.803.001-10.211-2.127-10.531-2.338v-9.81c.833-.442 5.281-2.972 5.281-6.601zm-9.781 5c0-.138.112-.25.25-.25h2.5c.138 0 .25.112.25.25v13.5c0 .136-.114.25-.25.25h-2.5c-.138 0-.25-.112-.25-.25z' />
        </svg>
        <p>{upvotes}</p>
      </div>
    </div>
  );
};
